<ng-container *ngIf="!isPageNotFound">
    <app-track-details-page [trackGuid]="this.guid" [destination]="this.destination"></app-track-details-page>
    <app-login *ngIf="!isUserLoggedIn && !isUser"></app-login>
</ng-container>
<ng-container *ngIf="isPageNotFound">
    <app-no-route></app-no-route>
</ng-container>